import { Settings2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

export interface DiscordAdvancedCalloutProps {
  onOpenAdvanced: () => void;
}

/**
 * Secondary path out of the one-click sheet. De-emphasized (no card chrome, muted context,
 * tucked under a divider) so the vast majority take the one-click "Add to your Discord server"
 * flow, while keeping a clearly-clickable "Advanced setup" button for advanced users.
 */
export const DiscordAdvancedCallout = ({ onOpenAdvanced }: DiscordAdvancedCalloutProps) => {
  const { t } = useTranslation(['integration']);

  return (
    <div className="mt-6 border-t border-border/50 pt-4" data-testid="discord-advanced-callout">
      <p className="text-sm font-medium text-muted-foreground">
        {t('integration:discord.oneclick.advanced_card.title')}
      </p>
      <p className="mt-1 mb-3 max-w-prose text-xs text-muted-foreground/90 text-pretty">
        {t('integration:discord.oneclick.advanced_card.description')}
      </p>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        className="cursor-pointer"
        onClick={onOpenAdvanced}
        data-testid="discord-open-advanced-button"
      >
        <Settings2 className="size-4" />
        {t('integration:discord.oneclick.advanced_link')}
      </Button>
    </div>
  );
};

export default DiscordAdvancedCallout;
